import { config } from '@/constants/page.js'
export default {
  accessToken(state) {
    if (!state.apiKey) {
      return false
    }
    return config[state.apiKey].accessToken
  },
  setting(state) {
    if (!state.apiKey) {
      return false
    }
    return config[state.apiKey]
  },
  page(state) {
    return state.page
  }
}
